import '@hapana/shared/utils/type-defs.util'

/** @type {Styles} */
export const styles = {
  row: {
    '&:not(:last-of-type)': {
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      borderBottomColor: 'gray.12',
    },
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    paddingY: 1.5,
    paddingX: 2,
  },
  headerClickable: {
    cursor: 'pointer',
  },
  headerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: 1.5,
    minWidth: 0,
  },
  titleBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
    minWidth: 0,
  },
  titleTruncate: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  headerActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    flexShrink: 0,
  },
  image: {
    width: 40,
    height: 'auto',
    maxHeight: 40,
    objectFit: 'contain',
    borderRadius: 0.5,
    flexShrink: 0,
  },
  chevron: {
    transition: 'transform 0.2s ease-in-out',
  },
  chevronExpanded: {
    transform: 'rotate(180deg)',
  },
  detailRow: {
    display: 'flex',
    borderTopStyle: 'solid',
    borderTopWidth: 1,
    borderTopColor: 'gray.12',
  },
  detailLabel: {
    width: 142,
    flexShrink: 0,
    backgroundColor: 'gray.3',
    paddingY: 1.5,
    paddingX: 2,
    height: 64,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  },
  detailValue: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
    paddingY: 1.5,
    paddingX: 2,
    height: 64,
    justifyContent: 'center',
  },
}
